import { useEffect, useState } from "react";
import { toast } from "sonner";
import { useAuthedGet } from "@/pages/Admin";
import { fmtDate } from "@/lib/api";

export const BansPanel = () => {
  const req = useAuthedGet();
  const [rows, setRows] = useState([]);
  const load = () => req("/admin/bans").then((r) => setRows(r.data)).catch(() => {});
  useEffect(() => { load(); }, []); // eslint-disable-line

  const unban = async (id) => {
    try { await req(`/admin/bans/${id}`, { method: "delete" }); toast.success("Tiltás feloldva"); load(); }
    catch { toast.error("Nem sikerült feloldani"); }
  };

  return (
    <div className="overflow-x-auto rounded-3xl border border-white/10 bg-[#1A152E]" data-testid="admin-bans-panel">
      <table className="w-full text-sm">
        <thead className="text-left text-xs uppercase tracking-widest text-muted-foreground">
          <tr>{["Állapot", "Becenév", "IP-cím", "Eszköz", "Indok", "Lejár", ""].map((h) => <th key={h} className="px-4 py-3 font-bold">{h}</th>)}</tr>
        </thead>
        <tbody>
          {rows.length === 0 && <tr><td colSpan={7} className="px-4 py-10 text-center text-muted-foreground" data-testid="bans-empty">Nincs kitiltott felhasználó.</td></tr>}
          {rows.map((b) => (
            <tr key={b.id} className="border-t border-white/5" data-testid={`admin-ban-row-${b.id}`}>
              <td className="px-4 py-3">
                <span className={`rounded-full px-3 py-1 text-xs font-bold ${b.active ? "bg-[#EF4444]/15 text-[#EF4444]" : "bg-white/5 text-muted-foreground"}`}>{b.active ? "Aktív" : "Lejárt / feloldva"}</span>
              </td>
              <td className="px-4 py-3 font-semibold">{b.nick || "—"}</td>
              <td className="px-4 py-3 font-mono text-xs">{b.ip || "—"}</td>
              <td className="max-w-[140px] truncate px-4 py-3 font-mono text-xs">{b.device_id || "—"}</td>
              <td className="max-w-[220px] truncate px-4 py-3 text-muted-foreground">{b.reason || "—"}</td>
              <td className="px-4 py-3 text-muted-foreground">{b.expires_at ? fmtDate(b.expires_at) : "Végleges"}</td>
              <td className="px-4 py-3 text-right">
                {b.active && (
                  <button onClick={() => unban(b.id)} data-testid="unban-button"
                    className="rounded-full bg-white/10 px-4 py-1.5 text-xs font-bold transition-colors hover:bg-white/20">Feloldás</button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
